// src/components/checkout/StripePaymentForm.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import axios from 'axios';

function StripePaymentForm({ total, onSuccess, onError }) {
  const { t, i18n } = useTranslation();
  const stripe = useStripe();
  const elements = useElements();
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setSubmitting(true);
    setErrorMsg(null);

    const cardElement = elements.getElement(CardElement);

    try {
      const { data } = await axios.post(
        'https://madadline.com/api/payment_intent',
        {
          amount: Math.round(total * 100),
          currency: 'mad',
        }
      );

      const clientSecret = data.clientSecret;
      if (!clientSecret) throw new Error(t('stripeForm.noClientSecret'));

      const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: { card: cardElement },
      });

      if (error) {
        setErrorMsg(error.message);
        onError?.(error.message);
        setSubmitting(false);
        return;
      }

      if (paymentIntent.status === 'succeeded') {
        onSuccess?.(paymentIntent.id);
      }
    } catch (err) {
      console.error('Erreur Stripe:', err);
      const msg = err.response?.data?.message || err.message || t('stripeForm.genericError');
      setErrorMsg(msg);
      onError?.(msg);
    } finally {
      setSubmitting(false);
    }
  };

  const cardStyle = {
    base: {
      fontSize: '15px',
      color: '#252525',
      fontFamily: i18n.language === 'ar' ? 'Tajawal, Cairo, sans-serif' : 'Inter, sans-serif',
      '::placeholder': { color: '#B5B0A0' },
    },
    invalid: {
      color: '#DC2626',
      iconColor: '#DC2626',
    },
  };

  return (
    <form onSubmit={handleSubmit} className="stripe-form">
      <div className="stripe-form__card">
        <CardElement options={{ style: cardStyle, hidePostalCode: false }} />
      </div>

      {errorMsg && (
        <div className="stripe-form__error">⚠️ {errorMsg}</div>
      )}

      <button
        type="submit"
        className="stripe-form__submit"
        disabled={!stripe || submitting}
      >
        {submitting
          ? t('stripeForm.paying')
          : t('stripeForm.pay', { total: total.toFixed(0) })}
      </button>

      <p className="stripe-form__secure">{t('stripeForm.secure')}</p>
    </form>
  );
}

export default StripePaymentForm;